export default "__VITE_PUBLIC_ASSET__5b2f74ca__"